export enum SupportedLanguages {
	DE = 'de',
	EN = 'en'
}

export const DEFAULT_LANGUAGE: SupportedLanguages = SupportedLanguages.DE;
